import { FC } from 'react';
import { EditableListDataGridLayout, EditableListFormShowTemplate } from 'framework/list';
import AssumptionsListHeader from './AssumptionsListHeader';
import { getAssumptionTableCells } from './getAssumptionTableCells';
import { ProjectSectionAccordion, useProjectDataContext } from 'domain/shared/newProject';

const AssumptionsList: FC = () => {
  const { data: projectData } = useProjectDataContext();

  return (
    <EditableListFormShowTemplate
      listSource="assumptions"
      localStorageKey={projectData?.id ? `project:${projectData.id}:assumptions` : undefined}
    >
      <ProjectSectionAccordion defaultExpanded title={<AssumptionsListHeader />}>
        <EditableListDataGridLayout
          rowProps={() => ({ sx: { alignItems: 'center', py: 2 } })}
          getRowEnabled={() => true}
          getTableCells={async () => getAssumptionTableCells()}
        />
      </ProjectSectionAccordion>
    </EditableListFormShowTemplate>
  );
};

export default AssumptionsList;
